import Phaser from 'phaser';
import { NotifyReactEvents } from 'Phaser/EventBus2';

export default class Empty extends Phaser.Scene {
  constructor() {
    super('Empty');
  }
  create(): void {
    console.log('scene: empty');
    NotifyReactEvents.CurrentSceneReady(this);
    NotifyReactEvents.PhaserReady();
  }
  init() {
    const font = this.add.text(0, 0, '.', {
      fontFamily: 'Lato',
      fontStyle: '900',
    });
    font.setAlpha(0);
    this.events.once('shutdown', () => font.destroy());
  }
  stop() {
    this.scene.stop();
  }
}
